var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex self-stretch p-4 w-full rounded-scrollbar"},[_c('EventOverview',{attrs:{"hideRegister":_vm.hideRegister}}),_c('WelcomeContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }